
import React from "react";
import PropTypes from "prop-types";

import { format, formatLocale } from "d3-format";

import { ChartCanvas, Chart, ZoomButtons } from "react-stockcharts";
import { XAxis, YAxis } from "react-stockcharts/lib/axes";
import { fitWidth } from "react-stockcharts/lib/helper";

import {
    CandlestickSeries,
    BollingerSeries,
    LineSeries,
    MACDSeries,
    AreaSeries,
    StraightLine,
    AlternatingFillAreaSeries,
    RSISeries,
    StochasticSeries,
    SARSeries,
    BarSeries,
    RenkoSeries,
    OHLCSeries,
    CircleMarker,
    ScatterSeries,
    KagiSeries
} from "react-stockcharts/lib/series";

import {
    ema, wma, sma, tma, macd, forceIndex, rsi, atr, stochasticOscillator, bollingerBand, sar, change, renko, kagi
} from "react-stockcharts/lib/indicator";

import {
    CurrentCoordinate, EdgeIndicator, MouseCoordinateY, CrossHairCursor, PriceCoordinate
} from "react-stockcharts/lib/coordinates";

import { discontinuousTimeScaleProvider } from "react-stockcharts/lib/scale";

import {
    OHLCTooltip,
    MACDTooltip,
    SingleValueTooltip, RSITooltip, StochasticTooltip, GroupTooltip
} from "react-stockcharts/lib/tooltip";

import {
    InteractiveText, TrendLine
} from "react-stockcharts/lib/interactive";

import {
    Label,
    Annotate,
    SvgPathAnnotation,
    buyPath,
    sellPath,
} from "react-stockcharts/lib/annotation";

import { THEME } from "../global/Theme";
import { last } from "react-stockcharts/lib/utils";

import { getOhlcFormat } from "../utils/CurrencyFormat"
import i18next from '../global/LocalizedStrings';


export const SCREENSHOT_NONE = 'none';
export const SCREENSHOT = 'capture';



var _d3TimeFormat = require("d3-time-format");

var charts = [];
var secondaryIndexs = [];
var willAddChartDatas = [];
var dealLines = [];

// const margin = { left: 50, right: 50, top: 10, bottom: 0 };
const yTickCount = 10;
const xTickCount = 10;
const BASE_DATA_COUNT = 60;

class StockChart extends React.Component {

    constructor(props) {
        super(props);
        this.saveNode = this.saveNode.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.buttonsNode = this.buttonsNode.bind(this);

        this.language = props.language;
    }

    saveNode(node) {
        this.node = node;
    }

    buttonsNode(node) {
        this.zoomButtonsNode = node;
    }

    handleReset() {
        this.reset = true;
        this.setState({
            suffix: this.state.suffix + 1
        });
    }

    componentWillMount() {
        this.reset = false;
        this.setState({
            suffix: 1
        });
    }

    getTradingList(tradeInfo) {

        const { data: initialData } = this.props;

        const textColor = 'white'
        const tradingList = []


        for (const idx in tradeInfo.list) {
            const trading = tradeInfo.list[idx];

            for (const i in trading.deals) {
                const deal = trading.deals[i];
                const position = deal.position;
                const bgFill = trading.type == "BUY" ? '#FF0000' : '#0000FF';

                const newText = {
                    text: deal.type,
                    fontWeight: "bold",
                    strokeWidth: 0,
                    textFill: textColor,
                    bgFill: bgFill,
                    bgOpacity: 0.7,
                    hoverText: {
                        enable: false,
                        bgHeight: 0,
                        bgWidth: 0,
                        text: "",
                        bgFill: '#000000'
                    },
                    position
                };

                tradingList.push(newText);
            }

            if (trading.deals.length == 1) {
                const dealLine = {
                    start: trading.deals[0].position,
                    end: [initialData.length - 1, tradeInfo.currentPrice],
                    appearance: {
                        stroke: trading.type == "BUY" ? '#FF0000' : '#0000FF',
                        strokeOpacity: 0.7,
                        strokeWidth: 2,
                        strokeDasharray: "Solid",
                        r: 0
                    },
                    type: "LINE"
                }

                dealLines.push(dealLine);
            }

            if (trading.deals.length == 2) {

                const dealLine = {
                    start: trading.deals[0].position,
                    end: trading.deals[1].position,
                    appearance: {
                        stroke: trading.type == "BUY" ? '#FF0000' : '#0000FF',
                        strokeOpacity: 0.7,
                        strokeWidth: 2,
                        strokeDasharray: "Solid",
                        r: 0
                    },
                    type: "LINE"
                }

                dealLines.push(dealLine);

            }
        }

        return tradingList;
    }

    setMAIndicator(ma, maType, data) {


        for (var idx in ma) {
            var value = ma[idx];
            if (value.show === true) {
                const dataKey = maType + value.size;

                var maData;
                switch (maType) {
                    case "SMA":
                        maData = sma().id(secondaryIndexs.length).options({ windowSize: Number(value.size) })
                        break;
                    case "WMA":
                        maData = wma().id(secondaryIndexs.length).options({ windowSize: Number(value.size) })
                        break;
                    case "EMA":
                        maData = ema().id(secondaryIndexs.length).options({ windowSize: Number(value.size) })
                        break;
                    case "TMA":
                        maData = tma().id(secondaryIndexs.length).options({ windowSize: Number(value.size) })
                        break;
                }

                maData = maData.merge((d, c) => { d[dataKey] = c; }).accessor(d => d[dataKey]);
                maData.maType = maType;
                maData.key = dataKey;
                data = maData(data);
                maData.strokeColor = value.color;
                secondaryIndexs.push(maData);
            }
        }


        return data
    }

    setChartPosition() {

        var { chartOption } = this.props;
        var chartProperty = chartOption.property;
        var additionalChart = chartOption.additionalChart;


        var mainChartHeight = 0.0;
        var additionalChartHeight = 0.0;
        var totalHeightRatio = 0.0;


        const chartDatas = [];

        for (const idx in additionalChart) {
            const chart = additionalChart[idx];
            if (chart.type == 'ForceIndex') {
                chartDatas.push(chart.short);
                chartDatas.push(chart.long);

                if (chart.short.show || chart.long.show) {
                    willAddChartDatas.push(chart);
                }

            } else if (chart.type == 'Stochastics') {
                chartDatas.push(chart.slow);
                chartDatas.push(chart.fast);
                chartDatas.push(chart.full);

                if (chart.slow.show || chart.fast.show || chart.full.show) {
                    willAddChartDatas.push(chart);
                }

            } else {
                chartDatas.push(chart);

                if (chart.show) {
                    willAddChartDatas.push(chart);
                }
            }
        }

        for (const idx in chartDatas) {
            const chart = chartDatas[idx];
            if (chart.type == 'volume') continue;
            if (chart.show) {
                additionalChartHeight += chart.heightRatio * 100;
                totalHeightRatio += chart.heightRatio
            }
        }

        mainChartHeight = chartProperty.height - additionalChartHeight;

        if (mainChartHeight < chartProperty.minMainChartHeight) {
            mainChartHeight = chartProperty.minMainChartHeight;
            additionalChartHeight = chartProperty.height - mainChartHeight;
        }


        chartProperty.mainChartHeight = mainChartHeight;

        var chartPosition = additionalChartHeight;

        for (const idx in chartDatas) {
            const chart = chartDatas[idx];
            if (chart.show) {
                if (chart.type != undefined && chart.type === 'volume') {
                    chart.position = additionalChartHeight + chart.height + 10;
                } else {
                    chart.height = (additionalChartHeight / totalHeightRatio) * chart.heightRatio
                    chart.position = chartPosition;
                    chartPosition -= chart.height
                }
            }
        }

        return chartOption;
    }

    setAdditionalCharts(calculatedData, chartOption) {


        const { capture, tradeInfo, theme } = this.props;
        const margin = capture ? { left: 0, right: 0, top: 10, bottom: 0 } : { left: 50, right: 50, top: 10, bottom: 0 }

        // 그리드
        const gridHeight = chartOption.property.height - margin.top - margin.bottom;
        const xGrid = { innerTickSize: -1 * gridHeight, tickStrokeOpacity: 0.1 };
        //**********************************************


        for (const idx in willAddChartDatas) {
            const chart = willAddChartDatas[idx];
            if (chart.show != undefined && chart.show == false) continue;

            const axisPosition = chart.type === 'volume' ? 'left' : 'right';
            const mouseCoordinate = (
                <MouseCoordinateY
                    at={axisPosition}
                    orient={axisPosition}
                    displayFormat={format(".4s")} />
            );

            const grid = idx == willAddChartDatas.length - 1 ? xGrid : {};

            if (chart.type === 'volume') {
                const volumeChart = (
                    <Chart
                        key={chart.type}
                        id={charts.length + 1}
                        origin={(w, h) => [0, h - chart.position]}
                        height={chart.height}
                        yExtents={d => d.volume}>

                        <XAxis axisAt="bottom" orient="bottom" showTickLabel={false} ticks={xTickCount} stroke={theme.lineColor} tickStroke={theme.lineColor} {...grid} />
                        <YAxis axisAt={axisPosition} orient={axisPosition} ticks={5} tickFormat={format(".2s")} tickStroke={theme.lineColor} stroke={theme.lineColor} />
                        {mouseCoordinate}
                        <BarSeries yAccessor={d => d.volume} fill={d => d.close > d.open ? "#6BA583" : "#DB0000"} />
                    </Chart>
                );

                charts.push(volumeChart);
            }


            if (chart.type === 'MACD') {

                const macdCalculator = macd()
                    .options({
                        fast: chart.fast,
                        slow: chart.slow,
                        signal: chart.signal,
                    })
                    .merge((d, c) => { d.macd = c; })
                    .accessor(d => d.macd);

                calculatedData = macdCalculator(calculatedData);

                const macdChart = (
                    <Chart
                        key={chart.type}
                        id={charts.length + 1}
                        height={chart.height}
                        yExtents={macdCalculator.accessor()}
                        origin={(w, h) => [0, h - chart.position]} padding={{ top: 10, bottom: 10 }}>

                        <XAxis axisAt="bottom" orient="bottom" showTickLabel={false} ticks={xTickCount} stroke={theme.lineColor} tickStroke={theme.lineColor} {...grid} />
                        <YAxis axisAt="right" orient="right" ticks={2} tickStroke={theme.lineColor} stroke={theme.lineColor} />

                        {mouseCoordinate}

                        <MACDSeries yAccessor={d => d.macd}
                            {...chart.macdAppearance} zeroLineStroke={theme.lineColor} />

                        <MACDTooltip
                            origin={[-40, 15]}
                            yAccessor={d => d.macd}
                            options={macdCalculator.options()}
                            appearance={chart.macdAppearance}
                            labelFill={theme.toolTipLabelColor}
                            displayValuesFor={tradeInfo.isGameData() ? this.displayValue : MACDTooltip.defaultProps.displayValuesFor}
                        />
                    </Chart>
                );

                charts.push(macdChart);
            }

            if (chart.type === 'RSI') {

                const rsiCalculator = rsi()
                    .options({ windowSize: chart.windowSize })
                    .merge((d, c) => { d.rsi = c; })
                    .accessor(d => d.rsi);

                calculatedData = rsiCalculator(calculatedData)


                const rsiChart = (
                    <Chart
                        key={chart.type}
                        id={charts.length + 1}
                        yExtents={[0, 100]}
                        height={chart.height}
                        origin={(w, h) => [0, h - chart.position]}
                    >
                        <XAxis axisAt="bottom" orient="bottom" showTickLabel={false} ticks={xTickCount} stroke={theme.lineColor} tickStroke={theme.lineColor} {...grid} />
                        <YAxis axisAt="right"
                            orient="right"
                            stroke={theme.lineColor}
                            tickValues={[chart.oversold, 50, chart.overbought]} tickStroke={theme.lineColor} />

                        {mouseCoordinate}

                        <RSISeries yAccessor={d => d.rsi} />

                        <RSITooltip origin={[-38, 15]}
                            yAccessor={d => d.rsi}
                            options={rsiCalculator.options()}
                            labelFill={theme.toolTipLabelColor}
                            textFill={theme.toolTipTextColor}
                            displayValuesFor={tradeInfo.isGameData() ? this.displayValue : RSITooltip.defaultProps.displayValuesFor}
                        />
                    </Chart>
                );

                charts.push(rsiChart);
            }

            if (chart.type === 'ATR') {

                const atrCalculator = atr()
                    .id(100)
                    .options({ windowSize: chart.windowSize })
                    .merge((d, c) => { d.atr14 = c; })
                    .accessor(d => d.atr14);

                calculatedData = atrCalculator(calculatedData)

                const atrChart = (
                    <Chart
                        key={chart.type}
                        id={charts.length + 1}
                        yExtents={atrCalculator.accessor()}
                        height={chart.height}
                        origin={(w, h) => [0, h - chart.position]}
                        padding={{ top: 10, bottom: 10 }}
                    >
                        <XAxis axisAt="bottom" orient="bottom" showTickLabel={false} ticks={xTickCount} stroke={theme.lineColor} tickStroke={theme.lineColor} {...grid} />
                        <YAxis axisAt="right" orient="right" ticks={2} stroke={theme.lineColor} tickStroke={theme.lineColor} />

                        {mouseCoordinate}

                        <LineSeries yAccessor={atrCalculator.accessor()} stroke={atrCalculator.stroke()} />
                        <SingleValueTooltip
                            yAccessor={atrCalculator.accessor()}
                            yLabel={`ATR (${atrCalculator.options().windowSize})`}
                            yDisplayFormat={format(".2f")}
                            labelFill={theme.toolTipLabelColor}
                            valueFill={theme.toolTipTextColor}
                            displayValuesFor={tradeInfo.isGameData() ? this.displayValue : SingleValueTooltip.defaultProps.displayValuesFor}
                            /* valueStroke={atr14.stroke()} - optional prop */
                            /* labelStroke="#4682B4" - optional prop */
                            origin={[-40, 15]} />
                    </Chart>
                );

                charts.push(atrChart);
            }

            if (chart.type === 'ForceIndex') {

                if (chart.short.show || chart.long.show) {

                    const fiShortTerm = forceIndex()
                        .merge((d, c) => { d.fi = c; })
                        .accessor(d => d.fi);

                    const fiLongTerm = ema()
                        .id(1)
                        .options({ windowSize: chart.long.term, sourcePath: "fi" })
                        .merge((d, c) => { d.fiLong = c; })
                        .accessor(d => d.fiLong);

                    calculatedData = fiLongTerm(fiShortTerm(calculatedData));

                    if (chart.short.show) {

                        const fiShortGrid = chart.long.show ? {} : grid;

                        const ForceIndexShort = chart.short;

                        const fiShortChart = (
                            <Chart
                                key={chart.type + 'short'}
                                id={charts.length + 1} height={ForceIndexShort.height}
                                yExtents={fiShortTerm.accessor()}
                                origin={(w, h) => [0, h - ForceIndexShort.position]}
                                padding={{ top: 10, right: 0, bottom: 10, left: 0 }}
                            >
                                <XAxis axisAt="bottom" orient="bottom" showTickLabel={false} ticks={xTickCount} stroke={theme.lineColor} tickStroke={theme.lineColor} {...fiShortGrid} />
                                <YAxis axisAt="right" orient="right" ticks={2} tickFormat={format(".2s")} stroke={theme.lineColor} tickStroke={theme.lineColor} />
                                {mouseCoordinate}

                                <AreaSeries baseAt={scale => scale(0)} yAccessor={fiShortTerm.accessor()} />
                                <StraightLine yValue={0} stroke={theme.lineColor} />

                                <SingleValueTooltip
                                    yAccessor={fiShortTerm.accessor()}
                                    yLabel="ForceIndex (1)"
                                    yDisplayFormat={format(".4s")}
                                    origin={[-40, 15]}
                                    labelFill={theme.toolTipLabelColor}
                                    valueFill={theme.toolTipTextColor}
                                    displayValuesFor={tradeInfo.isGameData() ? this.displayValue : SingleValueTooltip.defaultProps.displayValuesFor}

                                />
                            </Chart>
                        );

                        charts.push(fiShortChart);
                    }

                    if (chart.long.show) {
                        const ForceIndexLong = chart.long;

                        const fiLongChart = (
                            <Chart
                                key={chart.type + 'long'}
                                id={charts.length + 1} height={ForceIndexLong.height}
                                yExtents={fiLongTerm.accessor()}
                                origin={(w, h) => [0, h - ForceIndexLong.position]}
                                padding={{ top: 10, right: 0, bottom: 10, left: 0 }}
                            >

                                <XAxis axisAt="bottom" orient="bottom" showTickLabel={false} ticks={xTickCount} stroke={theme.lineColor} tickStroke={theme.lineColor} {...grid} />
                                <YAxis axisAt="right" orient="right" ticks={3} tickFormat={format(".2s")} stroke={theme.lineColor} tickStroke={theme.lineColor} />
                                {mouseCoordinate}

                                <AreaSeries baseAt={scale => scale(0)} yAccessor={fiLongTerm.accessor()} />
                                <AlternatingFillAreaSeries
                                    baseAt={0}
                                    yAccessor={fiLongTerm.accessor()}
                                />
                                <StraightLine yValue={0} stroke={theme.lineColor} />

                                <SingleValueTooltip
                                    yAccessor={fiLongTerm.accessor()}
                                    yLabel={`ForceIndex (${fiLongTerm.options().windowSize})`}
                                    yDisplayFormat={format(".4s")}
                                    origin={[-40, 15]}
                                    labelFill={theme.toolTipLabelColor}
                                    valueFill={theme.toolTipTextColor}
                                    displayValuesFor={tradeInfo.isGameData() ? this.displayValue : SingleValueTooltip.defaultProps.displayValuesFor}

                                />
                            </Chart>
                        );

                        charts.push(fiLongChart);
                    }
                }
            }


            if (chart.type === 'Stochastics') {

                const stoStroke = {
                    top: "#ff0000",
                    middle: theme.lineColor,
                    bottom: "#ff0000"
                }

                if (chart.slow.show) {

                    const stoGrid = chart.fast.show || chart.full.show ? {} : grid;
                    const stroke = { top: stoStroke.top, middle: stoStroke.middle, bottom: stoStroke.bottom, dLine: chart.slow.dLineColor, kLine: chart.slow.kLineColor };

                    const STO = stochasticOscillator()
                        .options({ windowSize: chart.slow.windowSize, kWindowSize: chart.slow.kSize, dWindowSize: chart.slow.dSize })
                        .merge((d, c) => { d.slowSTO = c; })
                        .accessor(d => d.slowSTO);

                    calculatedData = STO(calculatedData)

                    const STOChart = (
                        <Chart
                            key={chart.type + 'slow'}
                            id={charts.length + 1}
                            yExtents={[0, 100]}
                            height={chart.slow.height}
                            origin={(w, h) => [0, h - chart.slow.position]}
                            padding={{ top: 10, bottom: 10 }}
                        >
                            <XAxis axisAt="bottom" orient="bottom" showTickLabel={false} ticks={xTickCount} stroke={theme.lineColor} tickStroke={theme.lineColor} {...stoGrid} />
                            <YAxis axisAt="right" orient="right"
                                tickValues={[20, 50, 80]} stroke={theme.lineColor} tickStroke={theme.lineColor} />
                            {mouseCoordinate}

                            <StochasticSeries
                                yAccessor={d => d.slowSTO}
                                stroke={stroke} />

                            <StochasticTooltip
                                origin={[-38, 15]}
                                yAccessor={d => d.slowSTO}
                                options={STO.options()}
                                appearance={{ stroke: stroke }}
                                labelFill={theme.toolTipLabelColor}
                                displayValuesFor={tradeInfo.isGameData() ? this.displayValue : StochasticTooltip.defaultProps.displayValuesFor}
                                label="Slow STO"
                            />
                        </Chart>
                    );

                    charts.push(STOChart);
                }

                if (chart.fast.show) {

                    const stoGrid = chart.full.show ? {} : grid;

                    const stroke = { top: stoStroke.top, middle: stoStroke.middle, bottom: stoStroke.bottom, dLine: chart.fast.dLineColor, kLine: chart.fast.kLineColor }

                    const STO = stochasticOscillator()
                        .options({ windowSize: chart.fast.windowSize, kWindowSize: chart.fast.kSize, dWindowSize: chart.fast.dSize })
                        .merge((d, c) => { d.fastSTO = c; })
                        .accessor(d => d.fastSTO);

                    calculatedData = STO(calculatedData)

                    const STOChart = (
                        <Chart
                            key={chart.type + 'fast'}
                            id={charts.length + 1}
                            yExtents={[0, 100]}
                            height={chart.fast.height}
                            origin={(w, h) => [0, h - chart.fast.position]}
                            padding={{ top: 10, bottom: 10 }}
                        >
                            <XAxis axisAt="bottom" orient="bottom" showTickLabel={false} ticks={xTickCount} stroke={theme.lineColor} tickStroke={theme.lineColor} {...stoGrid} />
                            <YAxis axisAt="right" orient="right"
                                tickValues={[20, 50, 80]} stroke={theme.lineColor} tickStroke={theme.lineColor} />

                            {mouseCoordinate}

                            <StochasticSeries
                                yAccessor={d => d.fastSTO}
                                stroke={stroke} />

                            <StochasticTooltip
                                origin={[-38, 15]}
                                yAccessor={d => d.fastSTO}
                                options={STO.options()}
                                appearance={{ stroke: stroke }}
                                labelFill={theme.toolTipLabelColor}
                                displayValuesFor={tradeInfo.isGameData() ? this.displayValue : StochasticTooltip.defaultProps.displayValuesFor}
                                label="Fast STO" />
                        </Chart>
                    );

                    charts.push(STOChart);

                }
            }
        }

    }

    render() {

        charts = [];
        secondaryIndexs = [];
        willAddChartDatas = [];
        dealLines = [];

        const { type, width, data: initialData, ratio, panEvent, tradeInfo, capture, theme } = this.props;
        const margin = capture ? { left: 0, right: 0, top: 0, bottom: 0 } : { left: 50, right: 50, top: 10, bottom: 0 }

        const chartOption = this.setChartPosition();
        const chartProperty = chartOption.property;


        const index = chartOption.index;

        var calculatedData = initialData;

        var mainChart;
        //차트 종류

        if (chartProperty.chartType === "candle") {
            mainChart = (
                <CandlestickSeries
                    stroke={theme.barChartStrokeColor}
                    wickStroke={d => d.close > d.open ? THEME.getChartPositiveColor() : THEME.getChartNegativeColor()}
                    fill={d => d.close > d.open ? THEME.getChartPositiveColor() : THEME.getChartNegativeColor()}
                    stroke={d => d.close > d.open ? THEME.getChartPositiveColor() : THEME.getChartNegativeColor()}
                />
            );
        } else if (chartProperty.chartType === "ohlc") {
            const changeCalculator = change();
            calculatedData = changeCalculator(calculatedData);
            mainChart = (
                <OHLCSeries stroke={d => d.absoluteChange > 0 ? THEME.getChartPositiveColor() : THEME.getChartNegativeColor()} />
            );

        } else if (chartProperty.chartType === "area") {
            mainChart = (
                <AreaSeries
                    yAccessor={d => d.close}
                    stroke={theme.areaChartColor}
                    fill={theme.areaChartColor}
                />
            );
        } else if (chartProperty.chartType === "renko") {
            const renkoCalculator = renko();
            calculatedData = renkoCalculator(calculatedData);
            mainChart = (
                <RenkoSeries fill={{ up: THEME.getChartPositiveColor(), down: THEME.getChartNegativeColor() }} />
            );
        } else if (chartProperty.chartType === "kagi") {

            const kagiCalculator = kagi();
            calculatedData = kagiCalculator(calculatedData);

            mainChart = (
                <KagiSeries stroke={{ yang: THEME.getChartNegativeColor(), yin: THEME.getChartPositiveColor() }} />
            );


        } else {
            mainChart = [(
                <LineSeries
                    yAccessor={d => d.close} stroke={theme.lineChartColor} />
            ), (
                <ScatterSeries
                    yAccessor={d => d.close}
                    marker={CircleMarker}
                    markerProps={{ r: 3, fill: theme.lineChartColor }}
                />
            )];
        }

        // 단순 이동평균선
        this.setMAIndicator(index.sma, 'SMA', calculatedData);
        // 가중 이동평균선
        this.setMAIndicator(index.wma, 'WMA', calculatedData);
        // 지수 이동평균선
        this.setMAIndicator(index.ema, 'EMA', calculatedData);
        // 삼각가중 이동평균선
        this.setMAIndicator(index.tma, 'TMA', calculatedData);

        var maToolTips = [];
        secondaryIndexs.map(function (d) {
            maToolTips.push({
                yAccessor: d.accessor(),
                yLabel: `${d.type()}(${d.options().windowSize})`,
                valueFill: d.strokeColor,
                labelFill: theme.toolTipLabelColor,
                withShape: true,
            })
        })

        const secondaryIndexsAccessor = [];
        for (const idx in secondaryIndexs) {
            const maData = secondaryIndexs[idx];
            secondaryIndexsAccessor.push(maData.accessor());
        }

        var chartBollingerBand;

        if (index.BollingerBand.show) {

            const bb = bollingerBand()
                .merge((d, c) => { d.bb = c; })
                .accessor(d => d.bb);

            calculatedData = bb(calculatedData);

            secondaryIndexsAccessor.push(bb.accessor());

            chartBollingerBand = (
                <BollingerSeries yAccessor={d => d.bb}
                    stroke={{
                        top: index.BollingerBand.top,
                        middle: index.BollingerBand.middle,
                        bottom: index.BollingerBand.bottom,
                    }}
                    fill={index.BollingerBand.fill} />
            );
        }

        var chartSAR;

        if (index.SAR.show) {

            const propertySAR = index.SAR;
            const accelerationFactor = propertySAR.accelerationFactor;
            const maxAccelerationFactor = propertySAR.maxAccelerationFactor;

            const sarCalcurator = sar()
                .options({
                    accelerationFactor, maxAccelerationFactor
                })
                .merge((d, c) => { d.sar = c; })
                .accessor(d => d.sar);

            calculatedData = sarCalcurator(calculatedData);

            secondaryIndexsAccessor.push(sarCalcurator.accessor());

            chartSAR = (
                <SARSeries yAccessor={d => d.sar} fill={index.SAR.fill} />
            );
        }


        this.setAdditionalCharts(calculatedData, chartOption);


        // 그리드
        const gridHeight = chartProperty.height - margin.top - margin.bottom;
        const gridWidth = width - margin.left - margin.right;
        const yGrid = { innerTickSize: -1 * gridWidth, tickStrokeOpacity: 0.1 };
        const xGrid = charts.length == 0 ? { innerTickSize: -1 * gridHeight, tickStrokeOpacity: 0.1 } : {};
        //**********************************************

        const xScaleProvider = discontinuousTimeScaleProvider.inputDateAccessor(
            d => d.date
        );

        const { data, xScale, displayXAccessor, xAccessor } = xScaleProvider(
            calculatedData
        );

        const showDataCount = this.reset ? BASE_DATA_COUNT :
            this.zoomButtonsNode == undefined ? BASE_DATA_COUNT : this.zoomButtonsNode.context.plotData.length;

        if (this.reset) this.reset = false;

        const startValue = {
            capture: xAccessor(last(data)) + this.props.capturePadding,
            game: xAccessor(last(data)) + 2,
            viewer: xAccessor(last(data)) + 2,
        }

        const endValue = {
            capture: xAccessor(data[0]) - this.props.capturePadding,
            game: xAccessor(data[Math.max(0, data.length - showDataCount)]),
            viewer: xAccessor(data[0]) - 2,
        }


        const start = capture ? startValue.capture : tradeInfo.isGameData() ? startValue.game : startValue.viewer;
        const end = capture ? endValue.capture : tradeInfo.isGameData() ? endValue.game : endValue.viewer;

        const xExtents = [start, end];

        const yExtents = [d => [d.high, d.low]];

        for (const idx in secondaryIndexsAccessor) {
            const accessor = secondaryIndexsAccessor[idx];
            yExtents.push(accessor);
        }

        const tradingList = this.getTradingList(tradeInfo);

        if (tradeInfo.personDealInfo.state != "NONE") {
            yExtents.push(tradeInfo.personDealInfo.price);
        }

        const priceMarker = tradeInfo.personDealInfo.state == "NONE" ? "" : (
            <PriceCoordinate
                at="left"
                orient="left"
                price={tradeInfo.personDealInfo.price}
                opacity={0.8}
                lineStroke={tradeInfo.personDealInfo.state == "BUY" ? "red" : "blue"}
                strokeWidth={2}
                fill={tradeInfo.personDealInfo.state == "BUY" ? "#ff0000" : "#0000ff"}
                textFill="white"
                arrowWidth={7}
                strokeDasharray="ShortDash"
                displayFormat={format(".2f")}
            />
        );


        const ohlcFormat = getOhlcFormat(tradeInfo.stockCurrency)
        // i18next.changeLanguage(this.language)

        return (
            <div style={{ backgroundColor: theme.backgroundColor }}>
                <ChartCanvas
                    ref={(node) => this.chart = node}
                    panEvent={panEvent}
                    height={chartProperty.height}
                    ratio={ratio}
                    width={width}
                    margin={margin}
                    seriesName={`MSFT_${this.state.suffix}`}
                    type={type}
                    data={data}
                    xAccessor={xAccessor}
                    xExtents={xExtents}
                    xScale={xScale}
                    displayXAccessor={displayXAccessor}
                >
                    <Chart
                        id={0}
                        height={chartProperty.mainChartHeight - 20}
                        yExtents={yExtents}
                        padding={{ top: 10, bottom: 10 }}
                    >

                        <XAxis
                            axisAt="bottom"
                            orient="bottom"
                            showTickLabel={false}
                            ticks={xTickCount}
                            stroke={!capture ? theme.lineColor : '#00000000'}
                            tickStroke={theme.lineColor}
                            {...xGrid}
                        />

                        <YAxis
                            axisAt="right"
                            orient="right"
                            showTickLabel={!capture}
                            ticks={yTickCount}
                            tickStroke={theme.lineColor}
                            stroke={!capture ? theme.lineColor : '#00000000'}
                            {...yGrid} />

                        {
                            capture == false ? (
                                <MouseCoordinateY
                                    at="right"
                                    orient="right"
                                    displayFormat={format(".2f")}
                                />
                            ) : null
                        }


                        {mainChart}
                        {chartBollingerBand}
                        {chartSAR}

                        {secondaryIndexs.map(function (d) {
                            return (<LineSeries key={d.key} yAccessor={d.accessor()} stroke={d.strokeColor} />)
                        })}

                        {secondaryIndexs.map(function (d) {
                            return (<CurrentCoordinate key={d.key} yAccessor={d.accessor()} fill={d.strokeColor} />)
                        })}

                        <GroupTooltip
                            layout="vertical"
                            origin={[-38, 20]}
                            verticalSize={20}
                            onClick={e => console.log(e)}
                            options={maToolTips}
                            textFill={theme.toolTipTextColor}
                            labelFill={theme.toolTipLabelColor}
                            displayValuesFor={capture == false ? tradeInfo.isGameData() ? this.displayValue : GroupTooltip.defaultProps.displayValuesFor : this.displayValue}
                        />

                        {
                            capture == false ? (
                                <EdgeIndicator itemType="last" orient="right" edgeAt="right"
                                    yAccessor={d => d.close} fill={d => d.close > d.open ? THEME.getChartPositiveColor() : THEME.getChartNegativeColor()} />
                            ) : null
                        }

                        {
                            capture == false ? (
                                <OHLCTooltip
                                    // itemType="last"
                                    accessor={function accessor(d) {
                                        return {
                                            date: "",
                                            open: d.open,
                                            high: d.high,
                                            low: d.low,
                                            close: d.close,
                                            volume: d.volume
                                        };
                                    }}
                                    displayValuesFor={tradeInfo.isGameData() ? this.displayValue : OHLCTooltip.defaultProps.displayValuesFor}
                                    displayTexts={{
                                        d: "",
                                        o: i18next.t('ohlc.o'),
                                        h: i18next.t('ohlc.h'),
                                        l: i18next.t('ohlc.l'),
                                        c: i18next.t('ohlc.c'),
                                        v: i18next.t('ohlc.v'),
                                        // na: "   "
                                    }}
                                    xDisplayFormat={(0, _d3TimeFormat.timeFormat)("")}
                                    origin={[-40, 0]}
                                    textFill={theme.toolTipTextColor}
                                    labelFill={theme.toolTipLabelColor}
                                    ohlcFormat={ohlcFormat} />
                            ) : null
                        }

                        {
                            capture == false ? (
                                <ZoomButtons
                                    ref={this.buttonsNode}
                                    onReset={this.handleReset}
                                />
                            ) : null
                        }

                        <TrendLine
                            enabled={false}
                            type="LINE"
                            snap={true}
                            snapTo={d => [d.high, d.low]}
                            trends={dealLines}
                            hoverText={{ enable: false, bgHeight: 0, bgWidth: 0, text: "" }}
                        />

                        <InteractiveText
                            enabled={false}
                            // text="dd"
                            textList={tradingList}
                        />

                        {priceMarker}


                    </Chart>

                    {charts}

                    <CrossHairCursor stroke={theme.crossCursorColor} />
                </ChartCanvas>

            </div >
        );
    }

    displayValue(props, moreProps) {
        const { plotData } = moreProps;
        return plotData[plotData.length - 1];
    }

}

StockChart.propTypes = {
    data: PropTypes.array.isRequired,
    width: PropTypes.number.isRequired,
    ratio: PropTypes.number.isRequired,
    type: PropTypes.oneOf(["svg", "hybrid",]).isRequired,
};

StockChart.defaultProps = {
    type: "hybrid",
    panEvent: true,
};
StockChart = fitWidth(StockChart);

export default StockChart;




export const captureChartOption = {
    // chartType = candle, ohcl, area, line, renko, kagi
    property: {
        width: 2275 / window.devicePixelRatio,
        height: 1280 / window.devicePixelRatio,
        chartType: "candle",
        minMainChartHeight: 0
    },

    generalOption: {
        theme: 'LIGHT'
    },

    additionalChart: [
        { type: 'volume', show: false, },
        { type: 'MACD', show: false, },
        { type: 'ForceIndex', short: { show: false, }, long: { show: false, } },
        { type: 'RSI', show: false, },
        { type: 'ATR', show: false, },
        { type: 'Stochastics', slow: { show: false, }, fast: { show: false, }, full: { show: false, } },
    ],

    index: {
        sma: [{ show: false }, { show: false }, { show: false }, { show: false }, { show: false }, { show: false },],
        wma: [{ show: false }, { show: false }, { show: false }, { show: false }, { show: false }, { show: false },],
        ema: [{ show: false }, { show: false }, { show: false }, { show: false }, { show: false }, { show: false },],
        tma: [{ show: false }, { show: false }, { show: false }, { show: false }, { show: false }, { show: false },],
        BollingerBand: { show: false, },
        SAR: { show: false, },
    },
};

